import React from 'react';
import * as _cr from "./_cr";
import * as _ca from "./_ca";
import * as _hm from "./_hm";
import * as _hmDTM from "./_hmDTM";
import * as _ht from "./_ht";

import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as GridC from "./_cccGridC";
import * as TextC from "./_ccbTextC";

import { a } from "./_cmABT";
import * as ls from "./_csLcl";

//import * as ica from "src/ica";

export type tCdrCz = {
  cdrAbtz: _ht.dz,
  boxStlz: _ht.dz,
  cz: {
    dtmz: {
      crt: _ht.s,
      stt?: _ht.s,
      end?: _ht.s,
      hdys?: _ht.ls, // holliday
      dmds?: _ht.ls, // dimmed
    },
    onPrs: ( _date: _ht.s ) => void,
  }
};

let $dtm = _hmDTM.getTdy();

export const N = (pz: tCdrCz) => {

  const _udtThis = ls.udtThis();

  const _udtDtm = (dtm: _ht.s) => {
    $dtm = dtm;
    _udtThis();
  };

  React.useEffect(() => {
    if (pz.cz.dtmz.crt) {
      _udtDtm(_hmDTM.cvtFdm(pz.cz.dtmz.crt));
    }
  }, [
    pz.cz.dtmz.crt
  ])

  const _hdrCs = [] as _ht.ls;

  _hdrCs.push({
    boxStlz: a('dh/f dw/f fd/rac'),
    cellCs: [
      {
        boxStlz: a('f/1 fd/ccc'),
        boxClds: [
          _cr.c(BtnC.N, {
            key: -10,
            atrIconCz: {
              iconPtyz: a('icn/angle-double-left ics/4')
            },
            frmCz: {
              pslPtyz: {
                onPrs: () => {
                  _udtDtm(_hmDTM.addYear($dtm, -1));
                }
              }
            }
          })
        ]
      },
      {
        boxStlz: a('f/1 fd/ccc'),
        boxClds: [
          _cr.c(BtnC.N, {
            key: -10,
            atrIconCz: {
              iconPtyz: a('icn/angle-left ics/4')
            },
            frmCz: {
              pslPtyz: {
                onPrs: () => {
                  _udtDtm(_hmDTM.addMth($dtm, -1));
                }
              }
            }
          })
        ]
      },
      {
        boxStlz: a('f/2 fd/ccc'),
        boxClds: [
          _cr.c(TextC.N, {
            key: -10,
            text: _hmDTM.f($dtm, 'YYYY-MM'),
            textStlz: a('tb ts/l'),
          })
        ]
      },
      {
        boxStlz: a('f/1 fd/ccc'),
        boxClds: [
          _cr.c(BtnC.N, {
            key: -10,
            atrIconCz: {
              iconPtyz: a('icn/angle-right ics/4')
            },
            frmCz: {
              pslPtyz: {
                onPrs: () => {
                  _udtDtm(_hmDTM.addMth($dtm, 1));
                }
              }
            }
          })
        ]
      },
      {
        boxStlz: a('f/1 fd/ccc'),
        boxClds: [
          _cr.c(BtnC.N, {
            key: -10,
            backgroundColor: 'sc/rd1',
            atrIconCz: {
              iconPtyz: a('icn/angle-double-right ics/4')
            },
            frmCz: {
              pslPtyz: {
                onPrs: () => {
                  _udtDtm(_hmDTM.addYear($dtm, 1));
                }
              }
            }
          })
        ]
      },
    ]
  });

  const _bdyCs = [] as _ht.ls;

  _bdyCs.push({
    boxStlz: a('dh/4 dw/f sc/rd1'),
    cellCs: ['日', '月', '火', '水', '木', '金', '土'].map( ( _dow: _ht.s ) => {
      return {
        boxStlz: 
          _dow == '日' ?
            a('bc/lt9 bwb/1 bwl/1 dh/4 f/1 fd/ccc sc/lt3')
          : _dow == '土' ?
            a('bc/lt9 bwb/1 bwl/1 dh/4 f/1 fd/ccc sc/lt2')
          : a('bc/lt9 bwb/1 bwl/1 dh/4 f/1 fd/ccc sc/lt1'),
        boxClds: [
          _cr.c(TextC.N, {
            text: _dow,
          })
        ]
      }
    })
  });

  let _cellCs = [] as _ht.ls;

  const _stt = pz.cz.dtmz.stt ?? '0000-00-00 00:00:00';
  const _end = pz.cz.dtmz.end ?? '9999-12-31 23:59:59';

  _hmDTM.cvtCdrDates($dtm).map( ( _dtm: _ht.s, _nIdx: _ht.n ) => {

    if ( _nIdx > 0 && _nIdx % 7 == 0 ) {
      _bdyCs.push({
//        boxStlz: a('dw/f dh/f f/1 mb/0'),
        boxStlz: a('dw/f f/1'),
        cellCs: _cellCs
      });
      _cellCs = [];
    }

    _cellCs.push({
      boxStlz: a('dh/f f/1 sc/rd2'),
      boxClds: [
        _cr.c(BtnC.N, {
          frmCz: {
            pslStlz: a('dh/f dw/f'),
            pslPtyz: {
              onPrs: 
                _dtm >= _stt && _dtm <= _end && !_hm.i(_dtm, pz.cz.dtmz.dmds ?? []) ?
                () => {
                  pz.cz.onPrs(_dtm);
                }
                : undefined,
            },
            boxStlz: 
              _dtm < _stt || _dtm > _end ? // 外
                a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt4')
              : _hm.i(_dtm, pz.cz.dtmz.dmds ?? []) ? // 外
                a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt4')
              : _hm.i(_dtm, pz.cz.dtmz.hdys ?? []) ? // 祝
                a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt3')
              : _nIdx % 7 == 0 ? // 日
                a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt3')
              : _nIdx % 7 == 6 ? // 土
                a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt2')
              : a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt1'), // 平
          },
          lblCz: {
            text: _hmDTM.cvtDay(_dtm),
            textStlz: 
              _hmDTM.f(_dtm, 'YYYY-MM') == _hmDTM.f($dtm, 'YYYY-MM') ? // 同
                a('tc/lt9')
              : a('tc/lt5'), // 異
          }
        })
      ]
    }
    )
  });

  _bdyCs.push({
//    boxStlz: a('dw/f dh/f f/1 mb/0'),
    boxStlz: a('dw/f f/1'),
    cellCs: _cellCs
  }); // 最終行

  const _dw = _cr.d('p') ? 60 : 40;

  return (
    _cr.c(BoxC.N, {
      key: 'Cdr.root',
      boxStlz: a(`br/1 dh/70 dw/${_dw} sc/lt1`),
      boxClds: [

        _cr.c(GridC.N, {
          key: -10,
          boxStlz: a('dh/6 dw/f fd/rsc'),
          lineCs: _hdrCs,
        }),

        _cr.c(GridC.N, {
          key: -20,
          boxStlz: a('bc/lt9 bwt/1 bwr/1 dw/f f/1 sc/rd1'),
          lineCs: _bdyCs,
        })

      ]
    })
  )

};
